import React from 'react'
import { type IEducationItem } from '../server/user/info/education/list/get'
import Chip from './Chip'

interface IProps {
  item: IEducationItem
  className?: string
}

function EducationInfoItem(props: IProps): React.ReactElement {
  const { item } = props
  const { type } = item

  return (
    <div className={`education-info-item ${props.className ?? ''}`.trim()}>
      {type !== 'school' ? (
        <div
          className={
            'education-info-item__period text-body-small-bold text-secondary-color mb-1'
          }
        >
          {item.startYear} – {item.present ? 'н.в' : item.endYear}
        </div>
      ) : null}
      <div className="education-info-item__name text-body-bold">
        {item.university?.label ?? item.foreignUniversity ?? item.school}
      </div>
      <div className="education-info-item__text text-caption text-secondary-color">
        {item.speciality?.label ??
          item.foreignSpeciality ??
          `${item.region}, ${item.schoolType?.label}`}
      </div>
      {type === 'university' ? (
        <div className={'row row-gap-8 mt-md-5 mt-sm-4'}>
          {[item.form, item.basement, item.level].map((i: any) => {
            return (
              <Chip className={'text-secondary-color'} key={i.value}>
                {i.label}
              </Chip>
            )
          })}
        </div>
      ) : null}
    </div>
  )
}

export default EducationInfoItem
